/*!

=========================================================
* Material Dashboard PRO React - v1.9.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Switch, Redirect } from 'react-router-dom';
import { GuardProvider, GuardedRoute } from 'react-router-guards';
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux';
import moment from 'moment';
import axiosSetup from './axios-setup';
import ExtendedSnackbarProvider from 'components/Snackbar/ExtendedSnackbarProvider';
import EventProvider from 'eventBus/EventProvider';
import AuthLayout from 'layouts/Auth';
import AdminLayout from 'layouts/Admin';
import { store, persistor } from 'plugins/store/store';
import history from 'plugins/router/history';
import 'assets/scss/material-dashboard-pro-react.scss?v=1.9.0';
import ErrorPage from 'views/Pages/ErrorPage';
import { requireLogin } from 'plugins/router/guards';
import layoutNames from 'utils/enums/layout-names.enum';

axiosSetup(history);

moment.locale('en', {
	week:{
		dow : 0,
  },
});

const homeRoute = 'organizations';

ReactDOM.render(
	<Router history={history}>
		<GuardProvider guards={[requireLogin]} error={ErrorPage}>
			<Provider store={store}>
				<PersistGate loading={null} persistor={persistor}>
					<ExtendedSnackbarProvider
						maxSnack={3}
						anchorOrigin={{
							vertical: 'top',
							horizontal: 'right',
						}}
					>
						<EventProvider>
							<Switch>
								<Redirect from='/home' to={`/${layoutNames.portal}/${homeRoute}`} />
								<GuardedRoute path={`/${layoutNames.auth}/change-password`} component={AuthLayout} meta={{ auth: false }} />
								<GuardedRoute path={`/${layoutNames.auth}`} component={AuthLayout} />
								<GuardedRoute path={`/${layoutNames.portal}`} component={AdminLayout} meta={{ auth: true }} />
								<Redirect from='*' to={`/${layoutNames.portal}/${homeRoute}`} />
							</Switch>
						</EventProvider>
					</ExtendedSnackbarProvider>
				</PersistGate>
			</Provider>
		</GuardProvider>
	</Router>,
	document.getElementById('root')
);
